"use client";

import { useMemo, useState, type CSSProperties } from "react";
import { FiDownload, FiShare2 } from "react-icons/fi";
import { ShareModal } from "./share-modal";
import { useHolidayQuoteBrand } from "./contexts/use-holiday-quote-brand";
import { useQuoteTheme } from "./quote-theme/use-quote-theme";
import { cn } from "@/lib/utils";

export function QuoteHeader({ quoteId }: { quoteId: string }) {
  const { logo, quotesDomain, navBarTemplate, companyName } =
    useHolidayQuoteBrand();
  const { classNames, tokens } = useQuoteTheme();
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  // Get the current URL for sharing
  const quoteUrl = useMemo(() => {
    return `${quotesDomain}/${quoteId}`;
  }, [quoteId, quotesDomain]);

  if (navBarTemplate === "TYPE_2") {
    return (
      <header className={classNames.header} data-quote-sticky-header>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-center h-20">
            {/* Logo Section */}
            <div className="flex-shrink-0">
              <a href="#" className="flex items-center">
                <BrandMark logo={logo} companyName={companyName} />
              </a>
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <>
      <header className={classNames.header} data-quote-sticky-header>
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
            {/* Logo Section */}
            <div className="flex-shrink-0">
              <a href="#" className="flex items-center">
                <BrandMark logo={logo} companyName={companyName} />
              </a>
            </div>

            {/* Navigation Actions */}
            <div className="flex items-center space-x-4">
              {/* <button
                style={
                  {
                    backgroundColor: primaryColor,
                    "--tw-ring-color": primaryColor,
                  } as any
                }
                className={`inline-flex items-center px-2 sm:px-4 py-2 border border-transparent 
                           text-sm font-medium rounded-full text-white
                           hover:brightness-90 focus:outline-none focus:ring-2 
                           focus:ring-offset-2 transition-colors gap-2`}
              >
                <FiDownload className="w-4 h-4" />
                <span className="hidden sm:inline">Download PDF</span>
              </button> */}

              <button
                onClick={() => setIsShareModalOpen(true)}
                className="inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-2 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:px-4"
                style={
                  {
                    "--tw-ring-color": tokens.primary,
                  } as CSSProperties
                }
              >
                <FiShare2 className="w-4 h-4" />
                <span className="hidden sm:inline">Share Quote</span>
              </button>

              {/* Status Indicator - Hidden on mobile */}
              {/* <div className="hidden sm:flex items-center space-x-2">
                <div className="h-2.5 w-2.5 rounded-full bg-green-500"></div>
                <span className="text-sm text-gray-600">Quote Active</span>
              </div> */}
            </div>
          </div>
        </div>
      </header>

      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        quoteUrl={quoteUrl}
      />
    </>
  );
}

/** Logo, or the agency name when there is no logo (e.g. free quotes). */
function BrandMark({
  logo,
  companyName,
}: {
  logo: { src: string; alt: string };
  companyName: string;
}) {
  if (!logo.src) {
    return (
      <span
        className="text-xl font-semibold tracking-tight text-gray-900"
        style={{ fontFamily: "var(--quote-font-heading)" }}
      >
        {companyName || logo.alt}
      </span>
    );
  }
  return (
    <img
      src={logo.src}
      alt={logo.alt}
      height={60}
      className="h-[60px] w-auto object-contain"
    />
  );
}
